// extracted by mini-css-extract-plugin
module.exports = {"mainPopup":"ChangePassword_mainPopup__3hoB5","innerContainer":"ChangePassword_innerContainer__x5J8l"};